import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateSite } from "~pages/Sites/types/upsertSite.ts";
import type { Site, SiteResponse } from "~types/site.ts";

export const useUpdateSite = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<Site, Error, UpdateSite>({
    mutationFn: async ({ siteId, ...body }) => {
      const response = await request<SiteResponse>(`${sport}/o/${organizationId}/sites/${siteId}`, {
        method: "PUT",
        body,
      });

      return response?.data?.[0];
    },
    onSuccess: async (_site, { siteId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["sites"] }),
        queryClient.invalidateQueries({ queryKey: ["sites", sport, organizationId] }),
        queryClient.invalidateQueries({ queryKey: ["sites", organizationId, siteId] }),
      ]);
    },
  });
};
